"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendTaskMessage = void 0;
var utils_1 = require("../../utils");
exports.backendTaskMessage = function (axios) {
    return {
        postTaskMessages: function (request) {
            return axios.post('/task-messages', request.data);
        },
        getTaskMessagesInProgress: function () {
            return axios.get('/task-messages/in-progress');
        },
        getTaskMessagesTaskMessagesNo: function (request) {
            var url = utils_1.paramPathchange('/task-messages/{taskMessageNo}', request);
            return axios.get(url, request);
        },
        putTaskMessagesTaskMessageNo: function (request) {
            var url = utils_1.paramPathchange('/task-messages/{taskMessageNo}', request);
            return axios.put(url, request.data);
        },
        deleteTaskMessagesTaskMessageNo: function (request) {
            var url = utils_1.paramPathchange('/task-messages/{taskMessageNo}', request);
            return axios.delete(url, request);
        },
        /** @deprecated putTaskMessagesTaskMessageNoComplete 사용해주세요 */
        putTaskMessagesTaskMessageNoComplate: function (request) {
            var url = utils_1.paramPathchange('/task-messages/{taskMessageNo}/complete', request);
            return axios.put(url, request.data);
        },
        putTaskMessagesTaskMessageNoComplete: function (request) {
            var url = utils_1.paramPathchange('/task-messages/{taskMessageNo}/complete', request);
            return axios.put(url, request.data);
        },
        postTaskMessagesTaskMessageNoDetails: function (request) {
            var url = utils_1.paramPathchange('/task-messages/{taskMessageNo}/details', request);
            return axios.post(url, request.data);
        },
        getTaskMessagesTaskMessagesNoDetailsLast: function (request) {
            var url = utils_1.paramPathchange('/task-messages/{taskMessageNo}/details/last', request);
            return axios.get(url, request);
        },
        putTaskMessagesTaskMessageNoDetailsTaskMessageDetailNo: function (request) {
            var url = utils_1.paramPathchange('/task-messages/{taskMessageNo}/details/{taskMessageDetailNo}', request);
            return axios.put(url, request.data);
        },
        deleteTaskMessagesTaskMessageNoDetailsTaskMessageDetailNo: function (request) {
            var url = utils_1.paramPathchange('/task-messages/{taskMessageNo}/details/{taskMessageDetailNo}', request);
            return axios.delete(url, request);
        },
        getTaskMessages: function (request) {
            return axios.get('/task-messages', request);
        },
        getTaskMessagesSearch: function (request) {
            return axios.get('/task-messages/search', request);
        }
    };
};
